export default {
    ZOOM: "Масштаб",
    DELETE: "Удалить",
    DOWNLOAD: "Скачать",
    UPLOAD: "Импортировать",
    SHOW_NAMES: "Отображать названия",
    FILTER_TEXT_PLACEHOLDER: "Поиск",
    RELOAD: "Импорт ОМ с ТФМ",
    EXPORT: "Экспорт ОМ в ТФМ",
    ADD_DOCUMENT_OBJECT: "Добавить объект",
    SHOW_MODEL_ERRORS: "Показать ошибки модели"
};
